import React from "react";
import "./ProgressBar.css";

interface ProgressBarProps {
  progress: number;
  target: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress, target }) => {
  const isOverfill = progress > target;

  const fillWidth = (Math.min(progress, target) / target) * 100;

  return (
    <div className="progress-bar">
      <div
        className={`progress-bar-fill${isOverfill ? " overfill" : ""}`}
        style={{ width: `${fillWidth}%` }}
      ></div>
      <span className="progress-bar-label">
        {progress.toPrecision(2)}g / {target.toPrecision(2)}g
      </span>
    </div>
  );
};

export default ProgressBar;
